(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var root = document.documentElement;
    var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var drawer = null;
    var lastFocus = null;
    var closeTimer = null;

    function find() { drawer = document.querySelector('[data-cart-drawer]'); return drawer; }
    function reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function ms(token) { return parseFloat(getComputedStyle(root).getPropertyValue(token)) || 0; }
    function lock(on) {
      if (window.Motion) window.Motion.lock(on);
      else root.toggleAttribute('data-overlay-open', on);
      root.style.overflow = on ? 'hidden' : '';
    }

    /* ---------- drawer ---------- */
    function open() {
      if (!find()) return;
      clearTimeout(closeTimer);
      lastFocus = document.activeElement;
      drawer.hidden = false;
      drawer.removeAttribute('data-closing');
      void drawer.offsetWidth;
      drawer.setAttribute('data-open', '');
      lock(true);
      drawer.querySelector('[data-drawer-panel]').focus({ preventScroll: true });
      staggerItems();
    }
    function close() {
      if (!drawer || !drawer.hasAttribute('data-open')) return;
      drawer.setAttribute('data-closing', '');
      drawer.removeAttribute('data-open');
      lock(false);
      closeTimer = setTimeout(function () {
        drawer.hidden = true;
        drawer.removeAttribute('data-closing');
      }, ms('--dur-base'));
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function staggerItems() {
      var M = window.Motion;
      if (!M || M.reduced) return;
      window.gsap.from(drawer.querySelectorAll('[data-drawer-item]'), {
        opacity: 0, x: 24, duration: M.dur.base, ease: M.ease.enter, stagger: M.stagger, delay: 0.12, clearProps: 'opacity,transform'
      });
    }
    // Swap in fresh section HTML (Section Rendering API) and sync the header count.
    function paint(html) {
      if (!html || !find()) return;
      var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-drawer-panel]');
      if (!next) return;
      var panel = drawer.querySelector('[data-drawer-panel]');
      ['[data-drawer-body]', '.drawer__foot', '[data-drawer-count]', '[data-drawer-who]'].forEach(function (sel) {
        var from = next.querySelector(sel);
        var to = panel.querySelector(sel);
        if (from && to) to.replaceWith(from);
        else if (from) panel.appendChild(from);
        else if (to) to.remove();
      });
      var count = parseInt(panel.querySelector('[data-drawer-count]').textContent, 10) || 0;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }
    function refresh() {
      return fetch(routes + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { paint(data['cart-drawer']); });
    }

    /* ---------- add to cart ---------- */
    function feedback(btn) {
      if (!btn) return;
      if (!btn.querySelector('.btn__label')) {
        btn.setAttribute('data-add-to-cart', '');
        var label = document.createElement('span');
        label.className = 'btn__label';
        while (btn.firstChild) label.appendChild(btn.firstChild);
        btn.appendChild(label);
        var tpl = find() && drawer.querySelector('[data-check-icon]');
        if (tpl) {
          var check = tpl.content.firstElementChild.cloneNode(true);
          check.classList.add('btn__check');
          check.setAttribute('aria-hidden', 'true');
          btn.appendChild(check);
        }
      }
      btn.setAttribute('data-added', '');
      setTimeout(function () { btn.removeAttribute('data-added'); }, ms('--dur-base') + 900);
    }
    function bump() {
      document.querySelectorAll('.site-header__cart').forEach(function (el) {
        el.removeAttribute('data-bump');
        void el.offsetWidth;
        el.setAttribute('data-bump', '');
      });
    }
    // The mascot on stage reacts once per add: a hard cut to its strongest pose for 2s.
    function popMascot() {
      if (window.Motion && window.Motion.poses) window.Motion.poses.react('react-cart', 2000);
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action$="/cart/add"]') || !window.fetch || !find()) return;
      e.preventDefault();
      var btn = e.submitter || form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      fetch(routes + 'cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          paint(data.sections && data.sections['cart-drawer']);
          feedback(btn);
          bump();
          popMascot();
          setTimeout(open, reduced() ? 0 : ms('--dur-base'));
        })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });

    // Empty state: the hero's character, retargeted only while the drawer is closed.
    var featured = null;
    function retarget() {
      var fig = find() && drawer.querySelector('[data-drawer-empty] [data-mascot]');
      if (!fig || !featured || drawer.hasAttribute('data-open') || !window.Motion || !window.Motion.poses) return;
      if (fig.getAttribute('data-mascot') !== featured) window.Motion.poses.retarget(fig, featured, 'calm');
    }
    document.addEventListener('strippers:featured', function (e) { featured = e.detail.key; retarget(); });
    window.onMotion(retarget);

    /* ---------- drawer events ---------- */
    document.addEventListener('click', function (e) {
      var cartLink = e.target.closest('.site-header__cart');
      if (cartLink && find() && window.fetch) {
        e.preventDefault();
        refresh().then(open, function () { window.location.href = cartLink.href; });
        return;
      }
      if (e.target.closest('[data-drawer-close]')) { close(); return; }
      var line = e.target.closest('[data-line-set]');
      if (line && find()) {
        drawer.setAttribute('data-busy', '');
        fetch(routes + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.getAttribute('data-line-key'), quantity: parseInt(line.getAttribute('data-line-set'), 10), sections: ['cart-drawer'] })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) { paint(data.sections && data.sections['cart-drawer']); })
          .catch(function () { window.location.href = routes + 'cart'; })
          .then(function () { drawer.removeAttribute('data-busy'); drawer.querySelector('[data-drawer-panel]').focus({ preventScroll: true }); });
      }
    });

    // Esc closes; Tab stays inside the panel while it is open.
    document.addEventListener('keydown', function (e) {
      if (!drawer || !drawer.hasAttribute('data-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var panel = drawer.querySelector('[data-drawer-panel]');
      var items = Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex="0"]'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    });

    /* ---------- inputs: one shake on an invalid field ---------- */
    document.addEventListener('invalid', function (e) {
      var field = e.target.closest && e.target.closest('[data-field]');
      if (!field) return;
      field.removeAttribute('data-invalid');
      void field.offsetWidth;
      field.setAttribute('data-invalid', '');
    }, true);
    document.addEventListener('input', function (e) {
      var field = e.target.closest && e.target.closest('[data-field][data-invalid]');
      if (field && e.target.validity.valid) field.removeAttribute('data-invalid');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    function animated() { return !!(window.Motion && window.Motion.ready && !mq.matches); }

    function setup(catalog) {
      if (catalog.hasAttribute('data-ready')) return;
      catalog.setAttribute('data-ready', '');
      var grid = catalog.querySelector('[data-catalog-grid]');
      var sortSel = catalog.querySelector('[data-catalog-sort]');
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-formula-card]'));
      var sort = new URLSearchParams(location.search).get('sort_by') || 'featured';
      if (['featured', 'az', 'price'].indexOf(sort) < 0) sort = 'featured';

      function cast() { return document.documentElement.getAttribute('data-cast') === 'him' ? 'him' : 'her'; }
      function keyOf(card) {
        if (sort === 'az') return card.getAttribute('data-' + cast()).toLowerCase();
        if (sort === 'price') return parseInt(card.getAttribute('data-price'), 10) || 0;
        return parseInt(card.getAttribute('data-order'), 10) || 0;
      }
      // Re-append the cards in sort order (tab order follows the eye). The grid keeps its
      // height while the cards fade, so nothing jumps.
      function apply(push, animate) {
        if (sortSel) sortSel.value = sort;
        var ordered = cards.slice().sort(function (a, b) { var x = keyOf(a), y = keyOf(b); return x < y ? -1 : x > y ? 1 : 0; });
        grid.style.minHeight = grid.offsetHeight + 'px';
        function paint() { ordered.forEach(function (c) { grid.appendChild(c); }); }
        if (animate && animated()) {
          var M = window.Motion;
          window.gsap.to(grid, { opacity: 0, duration: M.dur.fast, ease: M.ease.exit, onComplete: function () {
            paint();
            window.gsap.set(grid, { opacity: 1 });
            window.gsap.from(ordered, { opacity: 0, y: 12, duration: M.dur.base, ease: M.ease.enter, stagger: M.stagger / 2, clearProps: 'opacity,transform',
              onComplete: function () { grid.style.minHeight = ''; } });
          } });
        } else {
          paint();
          grid.style.minHeight = '';
        }
        if (push && history.pushState) history.pushState({ sort: sort }, '', location.pathname + (sort === 'featured' ? '' : '?sort_by=' + sort));
      }

      if (sortSel) sortSel.addEventListener('change', function () { sort = sortSel.value; apply(true, true); });
      window.addEventListener('popstate', function (e) { sort = (e.state && e.state.sort) || 'featured'; apply(false, true); });
      // A-Z follows the character on show, so the cast toggle re-sorts.
      document.addEventListener('strippers:cast', function () { if (sort === 'az') apply(false, true); });
      // First paint: featured order (formula 1-13) without a fade; Shopify's own order stays without JS.
      apply(false, false);
    }

    function init(scope) { scope.querySelectorAll('[data-catalog]').forEach(setup); }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["credibility-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Facts fade up; their mono labels type on once (the only typing effect on the site).
    // The legal column, with the FDA disclaimer, is never touched: it is there at paint.
    function typeOn(label) {
      var text = label.textContent;
      // Screen readers get the whole label once; the typed characters are decorative.
      var full = document.createElement('span');
      full.className = 'visually-hidden';
      full.textContent = text;
      label.textContent = '';
      label.appendChild(full);
      var chars = text.split('').map(function (c) {
        var span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        span.textContent = c;
        label.appendChild(span);
        return span;
      });
      window.gsap.from(chars, { opacity: 0, duration: 0.01, stagger: 0.4 / Math.max(1, chars.length), ease: 'none' });
    }
    function setup(cred) {
      var M = window.Motion;
      if (!M || M.reduced || cred.hasAttribute('data-ready')) return;
      cred.setAttribute('data-ready', '');
      var facts = cred.querySelectorAll('[data-cred-reveal]');
      M.reveal(facts, { trigger: cred });
      M.onEnter(cred, function () { cred.querySelectorAll('[data-type-on]').forEach(typeOn); });
    }
    function init(scope) { window.onMotion(function () { scope.querySelectorAll('[data-cred]').forEach(setup); }); }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // After a successful signup the page reloads with the success line; one reaction.
    function setup(signup) {
      var M = window.Motion;
      if (!M || signup.hasAttribute('data-ready')) return;
      signup.setAttribute('data-ready', '');
      if (!signup.querySelector('.signup__success')) return;
      var fig = signup.querySelector('[data-mascot]');
      var st = M.poses && fig && M.poses.stage(fig, { toggle: false });
      M.onEnter(signup, function (instant) {
        if (!instant && st) st.react('react-cart', 2000);
      });
    }
    function init(scope) { window.onMotion(function () { scope.querySelectorAll('[data-signup]').forEach(setup); }); }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(faq) {
      if (faq.hasAttribute('data-ready')) return;
      faq.setAttribute('data-ready', '');
      var toggles = Array.prototype.slice.call(faq.querySelectorAll('[data-faq-toggle]'));
      function set(btn, open) {
        btn.setAttribute('aria-expanded', String(open));
        btn.closest('[data-faq-item]').toggleAttribute('data-open', open);
      }
      faq.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-faq-toggle]');
        if (btn) set(btn, btn.getAttribute('aria-expanded') !== 'true');
      });
      faq.addEventListener('keydown', function (e) {
        var i = toggles.indexOf(e.target);
        if (i < 0) return;
        var to = e.key === 'ArrowDown' ? i + 1 : e.key === 'ArrowUp' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? toggles.length - 1 : null;
        if (to === null) return;
        e.preventDefault();
        toggles[(to + toggles.length) % toggles.length].focus();
      });
      // A deep link to a question (#<id>-q) opens it.
      var target = location.hash && faq.querySelector(location.hash.replace(/-a$/, '-q'));
      if (target && target.hasAttribute('data-faq-toggle')) set(target, true);
    }
    function init(scope) { scope.querySelectorAll('[data-faq]').forEach(setup); }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    // The reverse wordmark fades in as a whole (opacity only; the mark itself never moves).
    function init(scope) {
      window.onMotion(function () {
        scope.querySelectorAll('[data-footer-mark]').forEach(function (mark) {
          window.Motion.reveal(mark, { y: 0, duration: window.Motion.dur.slow, start: 'top 95%' });
        });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formula-rail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    function animated() { return !!(window.Motion && window.Motion.ready && !mq.matches); }

    function setup(rail) {
      if (rail.hasAttribute('data-rail-ready')) return;
      rail.setAttribute('data-rail-ready', '');
      var track = rail.querySelector('[data-rail-track]');
      var bar = rail.querySelector('[data-rail-bar]');
      var prev = rail.querySelector('[data-rail-prev]');
      var next = rail.querySelector('[data-rail-next]');
      if (!track) return;
      var ticking = false;
      var glide = null;

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function max() { return track.scrollWidth - track.clientWidth; }
      function update() {
        ticking = false;
        var ratio = max() > 0 ? (track.scrollLeft + track.clientWidth) / track.scrollWidth : 1;
        if (bar) bar.style.transform = 'scaleX(' + Math.max(0.05, Math.min(1, ratio)) + ')';
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= max() - 1;
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }
      // Glide to a card boundary. Snap is suspended while we drive scrollLeft ourselves.
      function glideTo(x) {
        x = Math.max(0, Math.min(max(), Math.round(x / step()) * step()));
        if (!animated()) { track.scrollLeft = x; return; }
        if (glide) glide.kill();
        track.setAttribute('data-gliding', '');
        glide = window.gsap.to(track, {
          scrollLeft: x, duration: window.Motion.dur.slow, ease: window.Motion.ease.enter,
          onComplete: function () { track.removeAttribute('data-gliding'); glide = null; }
        });
      }
      function go(dir) { glideTo((glide ? glide.vars.scrollLeft : track.scrollLeft) + dir * step()); }

      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { go(-1); e.preventDefault(); }
      });

      // Mouse drag with momentum, then snap to a card. Touch keeps native scrolling + snap.
      var drag = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (glide) { glide.kill(); glide = null; }
        drag = { x: e.clientX, left: track.scrollLeft, lastX: e.clientX, lastT: e.timeStamp, v: 0, moved: false };
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) > 6) {
          drag.moved = true;
          track.setAttribute('data-gliding', '');
          track.setAttribute('data-dragging', '');
        }
        if (!drag.moved) return;
        track.scrollLeft = drag.left - dx;
        var dt = e.timeStamp - drag.lastT;
        if (dt > 0) drag.v = 0.8 * ((drag.lastX - e.clientX) / dt) + 0.2 * drag.v;
        drag.lastX = e.clientX;
        drag.lastT = e.timeStamp;
      });
      window.addEventListener('pointerup', function () {
        if (!drag) return;
        var d = drag;
        drag = null;
        if (!d.moved) return;
        track.removeAttribute('data-dragging');
        glideTo(track.scrollLeft + d.v * 320);
        // The click that follows a drag must not activate a card.
        var stop = function (e) { e.preventDefault(); e.stopPropagation(); };
        track.addEventListener('click', stop, { capture: true, once: true });
        setTimeout(function () { track.removeEventListener('click', stop, { capture: true }); }, 0);
      });
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Card lift, hover pose and wave: shared card behaviour in motion.js ([data-pose-card]).

      if (rail.hasAttribute('data-rail-reveal')) window.onMotion(function () { window.Motion.reveal(track.children, { trigger: rail }); });
      update();
    }

    // The card for the formula on the hero's stage carries the outline; a card tap
    // puts its formula on stage and brings the hero back into view.
    document.addEventListener('strippers:featured', function (e) {
      document.querySelectorAll('[data-formula-card]').forEach(function (card) {
        card.toggleAttribute('data-featured', card.getAttribute('data-formula-card') === e.detail.key);
      });
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hero-jump]');
      if (!btn) return;
      document.dispatchEvent(new CustomEvent('strippers:hero-jump', { detail: { key: btn.getAttribute('data-hero-jump') } }));
      var hero = document.querySelector('[data-hero]');
      if (!hero) return;
      if (window.Motion && window.Motion.lenis) window.Motion.scrollTo(0);
      else window.scrollTo({ top: 0, behavior: mq.matches ? 'auto' : 'smooth' });
    });

    function init(scope) { scope.querySelectorAll('[data-rail]').forEach(setup); }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var KEY = 'strippers.cast';
    var root = document.documentElement;

    function current() {
      return root.getAttribute('data-cast') === 'him' ? 'him' : 'her';
    }
    function sync() {
      var cast = current();
      document.querySelectorAll('[data-cast-set]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(btn.getAttribute('data-cast-set') === cast));
      });
    }
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var KNOB = 380;

    var landTimer = null;
    function land() {
      clearTimeout(landTimer);
      document.querySelectorAll('[data-cast-toggle]').forEach(function (t) { t.removeAttribute('data-landed'); });
      landTimer = setTimeout(function () {
        document.querySelectorAll('[data-cast-toggle]').forEach(function (t) { t.setAttribute('data-landed', ''); });
      }, KNOB - 120);
    }

    function set(cast) {
      var from = current();
      if (cast === from) return;
      // Stages pick the incoming pose first (motion.js).
      document.dispatchEvent(new CustomEvent('strippers:cast-will-change', { detail: { from: from, to: cast } }));
      root.setAttribute('data-cast', cast);
      try { localStorage.setItem(KEY, cast); } catch (e) {}
      sync();
      // Mascots, tins and names hard-cut with the data-cast flip (critical.css); only the knob slides.
      if (!reduced.matches) land();
      document.dispatchEvent(new CustomEvent('strippers:cast', { detail: { cast: cast } }));
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cast-set]');
      if (btn) set(btn.getAttribute('data-cast-set'));
    });

    // Inline search: the icon opens the bar under the header and focuses it; Esc or x closes.
    var header = document.querySelector('[data-site-header]');
    var bar = document.querySelector('[data-search-bar]');
    function searchOpen(on) {
      if (!bar) return;
      var toggle = document.querySelector('[data-search-toggle]');
      if (on) { bar.hidden = false; void bar.offsetWidth; }
      header.toggleAttribute('data-search-open', on);
      toggle.setAttribute('aria-expanded', String(on));
      if (on) { bar.querySelector('input').focus(); return; }
      setTimeout(function () { if (!header.hasAttribute('data-search-open')) bar.hidden = true; }, reduced.matches ? 0 : 220);
      toggle.focus();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-toggle]')) searchOpen(!header.hasAttribute('data-search-open'));
      else if (e.target.closest('[data-search-close]')) searchOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header && header.hasAttribute('data-search-open')) searchOpen(false);
    });

    // Nav drawer: open from the hamburger, close on scrim / x / Esc; Tab stays inside; scroll locked.
    var nav = document.querySelector('[data-nav-drawer]');
    var navLast = null;
    var navTimer = null;
    function ms() { return parseFloat(getComputedStyle(root).getPropertyValue('--dur-base')) || 0; }
    function navLock(on) {
      if (window.Motion) window.Motion.lock(on);
      else root.toggleAttribute('data-overlay-open', on);
      root.style.overflow = on ? 'hidden' : '';
    }
    function navOpen() {
      if (!nav) return;
      clearTimeout(navTimer);
      navLast = document.activeElement;
      nav.hidden = false;
      nav.removeAttribute('data-closing');
      void nav.offsetWidth;
      nav.setAttribute('data-open', '');
      document.querySelector('[data-nav-open]').setAttribute('aria-expanded', 'true');
      navLock(true);
      var panel = nav.querySelector('[data-nav-panel]');
      // The character only stays if everything fits without scrolling.
      panel.removeAttribute('data-tight');
      if (panel.scrollHeight > panel.clientHeight + 1) panel.setAttribute('data-tight', '');
      panel.focus({ preventScroll: true });
    }
    function navClose() {
      if (!nav || !nav.hasAttribute('data-open')) return;
      nav.setAttribute('data-closing', '');
      nav.removeAttribute('data-open');
      document.querySelector('[data-nav-open]').setAttribute('aria-expanded', 'false');
      navLock(false);
      navTimer = setTimeout(function () { nav.hidden = true; nav.removeAttribute('data-closing'); }, reduced.matches ? 0 : ms());
      if (navLast && navLast.focus) navLast.focus({ preventScroll: true });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nav-open]')) navOpen();
      else if (e.target.closest('[data-nav-close]')) navClose();
    });
    document.addEventListener('keydown', function (e) {
      if (!nav || !nav.hasAttribute('data-open')) return;
      if (e.key === 'Escape') { navClose(); return; }
      if (e.key !== 'Tab') return;
      var panel = nav.querySelector('[data-nav-panel]');
      var items = Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])'), function (el) { return el.offsetParent !== null; });
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    });

    // ← / → move between the two segments, like a radio pair.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var btn = e.target.closest && e.target.closest('[data-cast-set]');
      if (!btn) return;
      var cast = e.key === 'ArrowLeft' ? 'her' : 'him';
      var target = btn.parentNode.querySelector('[data-cast-set="' + cast + '"]');
      if (target) { target.focus(); set(cast); }
    });

    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-rotator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    function animated() { return !!(window.Motion && window.Motion.ready && !mq.matches); }

    // Wrap each headline word so it can stagger; cast-name spans already are words. Every word,
    // the cast names included, is followed by an explicit space text node, so the spacing does
    // not depend on whatever whitespace the markup carried (a lost node once glued the words).
    function splitWords(title) {
      if (!title || title.hasAttribute('data-split')) return;
      title.setAttribute('data-split', '');
      Array.prototype.slice.call(title.childNodes).forEach(function (node) {
        if (node.nodeType === 1) {
          node.classList.add('hero__word');
          title.insertBefore(document.createTextNode(' '), node.nextSibling);
          return;
        }
        if (node.nodeType !== 3) return;
        if (!node.textContent.trim()) { title.removeChild(node); return; }
        var frag = document.createDocumentFragment();
        node.textContent.split(/\s+/).forEach(function (part) {
          if (!part) return;
          var w = document.createElement('span');
          w.className = 'hero__word';
          w.textContent = part;
          frag.appendChild(w);
          frag.appendChild(document.createTextNode(' '));
        });
        title.replaceChild(frag, node);
      });
    }

    function parts(slide) {
      return {
        eyebrow: slide.querySelector('[data-hero-eyebrow]'),
        words: slide.querySelectorAll('.hero__word'),
        claim: slide.querySelector('[data-hero-claim]'),
        actions: slide.querySelector('[data-hero-actions]'),
        mascot: slide.querySelector('.hero__mascot'),
        tin: slide.querySelector('[data-hero-tin]')
      };
    }

    function setup(hero) {
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
      if (!slides.length || hero.hasAttribute('data-ready')) return;
      hero.setAttribute('data-ready', '');
      var gsap = window.gsap;
      var M = window.Motion;
      var dotsList = hero.querySelector('[data-hero-dots]');
      var bar = hero.querySelector('[data-hero-bar]');
      var count = hero.querySelector('[data-hero-count]');
      var interval = (parseInt(hero.getAttribute('data-interval'), 10) || 6000) / 1000;
      var autoplay = hero.getAttribute('data-autoplay') === 'true' && slides.length > 1;
      var current = 0;
      var tl = null;
      var progress = null;
      var holds = {};
      var dots = [];
      var fills = [];

      slides.forEach(function (slide, i) {
        splitWords(slide.querySelector('[data-hero-title]'));
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hero__dot';
        b.setAttribute('aria-label', (slide.getAttribute('data-her') || '') + ' & ' + (slide.getAttribute('data-him') || ''));
        b.innerHTML = '<span class="hero__dot-track"><span class="hero__fill"></span></span>';
        b.addEventListener('click', function () { go(i, i < current ? -1 : 1); });
        li.appendChild(b);
        dotsList.appendChild(li);
        dots.push(b);
        fills.push(b.querySelector('.hero__fill'));
      });

      // Warm the next slide, current cast only, and never inside the first-load window.
      var loaded = document.readyState === 'complete';
      if (!loaded) window.addEventListener('load', function () { loaded = true; preload(slides[(current + 1) % slides.length]); });
      function preload(slide) {
        if (!slide || !loaded) return;
        var cast = document.documentElement.getAttribute('data-cast') === 'him' ? 'him' : 'her';
        slide.querySelectorAll('img.cast-' + cast + '[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      }

      function activate(slide, on) {
        if (on) {
          slide.hidden = false;
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('inert');
          void slide.offsetWidth; // flush so the CSS fade (no-GSAP path) runs from 0
          slide.setAttribute('data-active', '');
        } else {
          slide.removeAttribute('data-active');
          slide.hidden = true;
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
        }
      }

      function mark() {
        var slide = slides[current];
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === current ? 'true' : 'false'); });
        if (count) count.textContent = (current + 1) + ' / ' + slides.length;
        var key = slide.getAttribute('data-key');
        hero.setAttribute('data-featured', key);
        // Inline so the tint starts crossfading with the exit, not at the swap
        // (first paint is covered by the :has rules).
        hero.style.setProperty('--tint', 'var(--tint-' + key + ')');
        hero.style.setProperty('--accent', 'var(--accent-' + key + ')');
        preload(slides[(current + 1) % slides.length]);
        document.dispatchEvent(new CustomEvent('strippers:featured', {
          detail: { key: key, her: slide.getAttribute('data-her'), him: slide.getAttribute('data-him') }
        }));
      }

      // Progress doubles as the autoplay clock: the current dot fills, then we advance.
      function runProgress() {
        if (progress) { progress.kill(); progress = null; }
        if (!gsap) return;
        gsap.set(fills.concat(bar || []), { clearProps: 'transform' });
        if (!autoplay || !animated()) return;
        progress = gsap.fromTo([fills[current], bar], { scaleX: 0 }, {
          scaleX: 1, duration: interval, ease: 'none', paused: true,
          onComplete: function () { go(current + 1, 1); }
        });
        sync();
      }
      function sync() {
        if (!progress) return;
        var held = document.hidden;
        for (var k in holds) { if (holds[k]) held = true; }
        held ? progress.pause() : progress.play();
      }
      function hold(reason, on) { holds[reason] = on; sync(); }

      function go(n, dir) {
        n = (n + slides.length) % slides.length;
        if (tl) tl.progress(1);
        if (n === current) return;
        var from = slides[current];
        var to = slides[n];
        current = n;
        if (progress) progress.pause();

        if (!animated()) {
          activate(from, false);
          activate(to, true);
          mark();
          runProgress();
          return;
        }

        var a = parts(from);
        var b = parts(to);
        var d = M.dur;
        tl = gsap.timeline({
          onComplete: function () {
            tl = null;
            gsap.set([a.mascot, a.tin, a.eyebrow, a.claim, a.actions].concat(Array.prototype.slice.call(a.words)), { clearProps: 'opacity,transform' });
            runProgress();
          }
        });
        mark();
        if (progress) { progress.kill(); progress = null; }
        if (autoplay) gsap.set([fills[current], bar], { scaleX: 0 }); // refills once the new slide lands
        // Out: mascot slides off against the direction of travel, copy and tin drop away.
        tl.to(a.mascot, { x: -60 * dir, opacity: 0, duration: d.base, ease: M.ease.exit }, 0)
          .to(a.tin, { y: 24, opacity: 0, duration: d.base, ease: M.ease.exit }, 0)
          .to([a.eyebrow, a.words, a.claim, a.actions], { opacity: 0, duration: d.fast, ease: M.ease.exit }, 0)
          .add(function () { activate(from, false); activate(to, true); }, d.base)
          // In
          .fromTo(b.mascot, { x: 60 * dir, opacity: 0 }, { x: 0, opacity: 1, duration: d.slow, ease: M.ease.enter }, d.base)
          .fromTo(b.eyebrow, { opacity: 0 }, { opacity: 1, duration: d.fast }, d.base)
          .fromTo(b.words, { y: 16, opacity: 0 }, { y: 0, opacity: 1, duration: d.base, stagger: M.stagger, ease: M.ease.enter }, d.base + 0.04)
          .fromTo(b.tin, { y: 24, opacity: 0 }, { y: 0, opacity: 1, duration: d.base, ease: M.ease.enter }, d.base + 0.12)
          .fromTo([b.claim, b.actions], { opacity: 0 }, { opacity: 1, duration: d.base, stagger: M.stagger }, d.base + 0.2);
      }

      // One-time entrance. The page painted in its end state; the LCP mascot only moves
      // (no opacity), and we skip the whole thing if the script arrived late.
      function entrance() {
        if (!animated() || performance.now() > 2000 || window.scrollY > 40) return;
        var p = parts(slides[current]);
        var d = M.dur;
        gsap.timeline({ defaults: { ease: M.ease.enter } })
          .from(p.eyebrow, { opacity: 0, duration: d.fast }, 0)
          .from(p.words, { y: 16, opacity: 0, duration: d.base, stagger: M.stagger }, 0.06)
          .from(p.mascot, { x: 40, duration: d.slow }, 0)
          .from(p.tin, { y: 24, opacity: 0, duration: d.base }, 0.12)
          .from(p.claim, { opacity: 0, duration: d.base }, 0.3)
          .from(p.actions, { opacity: 0, duration: d.base }, 0.5);
      }

      // Parallax: mascot at 0.85x, tin at 0.92x of scroll, via one CSS variable.
      function parallax() {
        if (!animated()) return;
        window.ScrollTrigger.create({
          trigger: hero, start: 'top top', end: 'bottom top',
          onUpdate: function (self) { hero.style.setProperty('--hero-scroll', Math.round(self.progress * hero.offsetHeight)); }
        });
      }

      // Lean: pointer on desktop, device tilt on touch. Lerped on the GSAP ticker.
      var lean = { x: 0, y: 0, tx: 0, ty: 0, on: false };
      function leanTick() {
        lean.x += (lean.tx - lean.x) * 0.08;
        lean.y += (lean.ty - lean.y) * 0.08;
        hero.style.setProperty('--lean-x', lean.x.toFixed(3));
        hero.style.setProperty('--lean-y', lean.y.toFixed(3));
        if (Math.abs(lean.tx - lean.x) < 0.002 && Math.abs(lean.ty - lean.y) < 0.002) {
          gsap.ticker.remove(leanTick);
          lean.on = false;
        }
      }
      function leanTo(x, y) {
        if (!animated()) return;
        lean.tx = Math.max(-1, Math.min(1, x));
        lean.ty = Math.max(-1, Math.min(1, y));
        if (!lean.on) { lean.on = true; gsap.ticker.add(leanTick); }
      }
      function onTilt(e) {
        if (e.gamma == null || holds.offscreen) return;
        leanTo(e.gamma / 30, (e.beta - 45) / 30);
      }
      function tilt() {
        var D = window.DeviceOrientationEvent;
        if (!D || !window.matchMedia('(pointer: coarse)').matches) return;
        if (typeof D.requestPermission === 'function') {
          // iOS: ask once, from a tap inside the hero. Denied = silently off.
          hero.addEventListener('touchend', function ask() {
            hero.removeEventListener('touchend', ask);
            D.requestPermission().then(function (state) {
              if (state === 'granted') window.addEventListener('deviceorientation', onTilt);
            }).catch(function () {});
          });
        } else {
          window.addEventListener('deviceorientation', onTilt);
        }
      }

      // Idle life: a 1.5% breath every 4-7s, never alongside a rotation.
      function breathe() {
        if (!gsap) return;
        gsap.delayedCall(4 + Math.random() * 3, function () {
          var clear = !progress || (progress.time() > 1 && progress.duration() - progress.time() > 1.4);
          if (animated() && !tl && !holds.offscreen && !document.hidden && clear) {
            var cast = document.documentElement.getAttribute('data-cast') === 'him' ? 'him' : 'her';
            var img = slides[current].querySelector('.mascot__img.cast-' + cast);
            gsap.to(img, { scale: 1.015, duration: 0.45, ease: M.ease.move, yoyo: true, repeat: 1, transformOrigin: '50% 100%' });
          }
          breathe();
        });
      }

      hero.querySelector('[data-hero-prev]').addEventListener('click', function () { go(current - 1, -1); });
      hero.querySelector('[data-hero-next]').addEventListener('click', function () { go(current + 1, 1); });

      hero.addEventListener('mouseenter', function () { hold('hover', true); });
      hero.addEventListener('mouseleave', function () { hold('hover', false); leanTo(0, 0); });
      hero.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = hero.getBoundingClientRect();
        leanTo(((e.clientX - r.left) / r.width) * 2 - 1, ((e.clientY - r.top) / r.height) * 2 - 1);
      });
      hero.addEventListener('focusin', function () { hold('focus', true); });
      hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) hold('focus', false); });
      document.addEventListener('visibilitychange', sync);
      if (mq.addEventListener) mq.addEventListener('change', runProgress);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          hold('offscreen', !entries[0].isIntersecting);
        }, { threshold: 0.25 }).observe(hero);
      }

      // Touch: hold pauses, swipe left/right steps.
      var touchX = null;
      hero.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; hold('touch', true); }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        hold('touch', false);
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) > 48) go(dx < 0 ? current + 1 : current - 1, dx < 0 ? 1 : -1);
      }, { passive: true });
      hero.addEventListener('touchcancel', function () { touchX = null; hold('touch', false); }, { passive: true });

      // A formula card can put its formula on stage; rotation then rests for 10s.
      var jumpTimer = null;
      document.addEventListener('strippers:hero-jump', function (e) {
        var key = e.detail && e.detail.key;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-key') !== key) continue;
          go(i, i < current ? -1 : 1);
          hold('jump', true);
          clearTimeout(jumpTimer);
          jumpTimer = setTimeout(function () { hold('jump', false); }, 10000);
          break;
        }
      });

      mark();
      // Section scripts may register after this one; re-announce once the stack clears.
      setTimeout(mark, 0);
      // The carousel works as soon as it is parsed; choreography joins when the motion stack lands.
      window.onMotion(function () {
        gsap = window.gsap;
        M = window.Motion;
        if (!animated()) return;
        hero.setAttribute('data-animated', '');
        runProgress();
        entrance();
        parallax();
        tilt();
        breathe();
      });
    }

    function init(scope) { scope.querySelectorAll('[data-hero]').forEach(setup); }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(sec) {
      if (sec.hasAttribute('data-ready')) return;
      sec.setAttribute('data-ready', '');
      var demo = sec.querySelector('[data-demo]');
      var beats = Array.prototype.slice.call(sec.querySelectorAll('[data-beat]'));
      var motifs = Array.prototype.slice.call(sec.querySelectorAll('[data-motif] [data-dissolve]'));
      if (!demo) return;
      // The beats and the motif follow the loop's timeline; data-playing mirrors the demo's.
      demo.addEventListener('demo:progress', function (e) {
        var p = e.detail.progress;
        sec.toggleAttribute('data-playing', demo.hasAttribute('data-playing'));
        beats.forEach(function (b) { b.toggleAttribute('data-active', p >= parseFloat(b.getAttribute('data-from')) && p < parseFloat(b.getAttribute('data-to'))); });
        motifs.forEach(function (m) {
          var at = parseFloat(m.parentNode.getAttribute('data-at'));
          m.style.setProperty('--p', Math.max(0, Math.min(1, (p - at + 0.17) / 0.34)).toFixed(3));
        });
      });
      new MutationObserver(function () { sec.toggleAttribute('data-playing', demo.hasAttribute('data-playing')); }).observe(demo, { attributes: true, attributeFilter: ['data-playing'] });
    }
    function init(scope) {
      if (scope.matches && scope.matches('[data-hiw]')) setup(scope);
      else scope.querySelectorAll('[data-hiw]').forEach(setup);
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) init(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(marquee) {
      var track = marquee.querySelector('[data-marquee-track]');
      if (!track || !track.getAnimations || marquee.hasAttribute('data-ready')) return;
      marquee.setAttribute('data-ready', '');
      track.style.setProperty('--marquee-duration', Math.max(10, track.scrollWidth / 2 / 40) + 's');
      var anim = track.getAnimations()[0];
      if (!anim) return; // reduced motion
      var rate = 1;
      var target = 1;
      var held = false;
      var lastY = window.scrollY;
      var raf = null;

      // Scroll velocity leans the drift (and reverses it on the way up), clamped, easing home.
      function tick() {
        raf = null;
        var y = window.scrollY;
        var v = y - lastY;
        lastY = y;
        target = held ? 0 : Math.max(-3, Math.min(3, 1 + v * 0.12));
        if (!held && Math.abs(v) < 0.5) target = 1;
        rate += (target - rate) * 0.08;
        anim.playbackRate = Math.abs(rate) < 0.01 ? 0 : rate;
        if (Math.abs(target - rate) > 0.01 || Math.abs(v) >= 0.5) raf = requestAnimationFrame(tick);
      }
      function wake() { if (!raf) raf = requestAnimationFrame(tick); }
      function hold(on) { held = on; wake(); }

      window.addEventListener('scroll', wake, { passive: true });
      marquee.addEventListener('mouseenter', function () { hold(true); });
      marquee.addEventListener('mouseleave', function () { hold(false); });
      marquee.addEventListener('touchstart', function () { hold(true); }, { passive: true });
      marquee.addEventListener('touchend', function () { hold(false); }, { passive: true });
      marquee.addEventListener('touchcancel', function () { hold(false); }, { passive: true });
    }
    function init(scope) { scope.querySelectorAll('[data-marquee]').forEach(setup); }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    function animated() { return !!(window.Motion && window.Motion.ready && !mq.matches); }

    function setup(pdp) {
      if (pdp.hasAttribute('data-ready')) return;
      pdp.setAttribute('data-ready', '');

      /* ---------- gallery ---------- */
      var track = pdp.querySelector('[data-gallery-track]');
      var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-gallery-go]'));
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      var index = 0;
      var glide = null;
      var ticking = false;

      function mark(i) {
        index = i;
        thumbs.forEach(function (t, n) { t.setAttribute('aria-pressed', String(n === i)); });
      }
      function go(i, instant) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        var x = i * track.clientWidth;
        mark(i);
        if (glide) { glide.kill(); glide = null; }
        if (instant || !animated()) {
          track.removeAttribute('data-gliding');
          track.scrollLeft = x;
          return;
        }
        track.setAttribute('data-gliding', '');
        glide = window.gsap.to(track, {
          scrollLeft: x, duration: window.Motion.dur.base, ease: window.Motion.ease.move,
          onComplete: function () { track.removeAttribute('data-gliding'); glide = null; }
        });
      }
      // Slides 2+ trade their thumbnail for the real file once the page has loaded, or at first touch.
      function hydrate() {
        if (!track) return;
        track.querySelectorAll('img[data-srcset]').forEach(function (im) {
          im.srcset = im.getAttribute('data-srcset');
          im.removeAttribute('data-srcset');
        });
      }
      if (document.readyState === 'complete') hydrate();
      else window.addEventListener('load', hydrate);
      if (track) {
        ['pointerdown', 'touchstart', 'focusin'].forEach(function (type) {
          pdp.querySelector('[data-gallery]').addEventListener(type, hydrate, { once: true, passive: true });
        });
        track.addEventListener('scroll', function () {
          if (ticking || glide) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            if (!glide) mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
          });
        }, { passive: true });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { go(index + 1); e.preventDefault(); }
          if (e.key === 'ArrowLeft') { go(index - 1); e.preventDefault(); }
        });
        window.addEventListener('resize', function () { go(index, true); }, { passive: true });
      }

      /* ---------- zoom ---------- */
      var box = pdp.querySelector('[data-lightbox]');
      var panel = box && box.querySelector('[data-lightbox-panel]');
      var view = box && box.querySelector('[data-lightbox-view]');
      var img = box && box.querySelector('[data-lightbox-img]');
      var count = box && box.querySelector('[data-lightbox-count]');
      var lastFocus = null;
      var closeTimer = null;
      var zoom = { on: false, x: 0, y: 0 };
      var drag = null;

      function lock(on) {
        if (window.Motion) window.Motion.lock(on);
        document.documentElement.style.overflow = on ? 'hidden' : '';
      }
      function applyZoom() {
        img.style.transform = zoom.on ? 'translate(' + zoom.x + 'px,' + zoom.y + 'px) scale(2)' : '';
        box.toggleAttribute('data-zoomed', zoom.on);
      }
      function clampPan() {
        var mx = img.clientWidth / 2;
        var my = img.clientHeight / 2;
        zoom.x = Math.max(-mx, Math.min(mx, zoom.x));
        zoom.y = Math.max(-my, Math.min(my, zoom.y));
      }
      function point(i) {
        i = (i + slides.length) % slides.length;
        zoom = { on: false, x: 0, y: 0 };
        applyZoom();
        img.src = slides[i].querySelector('[data-gallery-zoom]').getAttribute('data-full');
        img.alt = slides[i].querySelector('img').alt;
        count.textContent = (i + 1) + ' / ' + slides.length;
        go(i, true);
      }
      function openBox(i) {
        clearTimeout(closeTimer);
        lastFocus = document.activeElement;
        box.hidden = false;
        point(i);
        void box.offsetWidth;
        box.setAttribute('data-open', '');
        lock(true);
        panel.focus({ preventScroll: true });
      }
      function closeBox() {
        if (!box.hasAttribute('data-open')) return;
        box.removeAttribute('data-open');
        lock(false);
        var wait = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dur-base')) || 0;
        closeTimer = setTimeout(function () { box.hidden = true; }, wait);
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
      if (box) {
        // Tap toggles 2x around the tap point; drag pans while zoomed; a sideways flick at 1x steps.
        view.addEventListener('pointerdown', function (e) {
          drag = { x: e.clientX, y: e.clientY, zx: zoom.x, zy: zoom.y, moved: false };
          view.setPointerCapture(e.pointerId);
        });
        view.addEventListener('pointermove', function (e) {
          if (!drag) return;
          var dx = e.clientX - drag.x;
          var dy = e.clientY - drag.y;
          if (Math.abs(dx) + Math.abs(dy) > 8) drag.moved = true;
          if (!zoom.on || !drag.moved) return;
          box.setAttribute('data-panning', '');
          zoom.x = drag.zx + dx;
          zoom.y = drag.zy + dy;
          clampPan();
          applyZoom();
        });
        view.addEventListener('pointerup', function (e) {
          if (!drag) return;
          var d = drag;
          drag = null;
          box.removeAttribute('data-panning');
          var dx = e.clientX - d.x;
          if (!d.moved) {
            var r = img.getBoundingClientRect();
            zoom.on = !zoom.on;
            zoom.x = zoom.on ? (r.left + r.width / 2 - e.clientX) : 0;
            zoom.y = zoom.on ? (r.top + r.height / 2 - e.clientY) : 0;
            if (zoom.on) clampPan();
            applyZoom();
          } else if (!zoom.on && Math.abs(dx) > 48) {
            point(index + (dx < 0 ? 1 : -1));
          }
        });
        view.addEventListener('pointercancel', function () { drag = null; box.removeAttribute('data-panning'); });
        view.addEventListener('click', function (e) {
          // Keyboard activation only (pointer taps are handled above): toggle around the centre.
          if (e.detail !== 0) return;
          zoom.on = !zoom.on;
          zoom.x = zoom.y = 0;
          applyZoom();
        });
      }

      pdp.addEventListener('click', function (e) {
        var t = e.target.closest('[data-gallery-go]');
        if (t) { go(parseInt(t.getAttribute('data-gallery-go'), 10)); return; }
        var z = e.target.closest('[data-gallery-zoom]');
        if (z && box) { openBox(parseInt(z.getAttribute('data-gallery-zoom'), 10)); return; }
        var s = e.target.closest('[data-lightbox-step]');
        if (s) { point(index + parseInt(s.getAttribute('data-lightbox-step'), 10)); return; }
        if (e.target.closest('[data-lightbox-close]')) { closeBox(); return; }
        var step = e.target.closest('[data-qty-step]');
        if (step) {
          var input = step.parentNode.querySelector('input');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
        }
      });
      document.addEventListener('keydown', function (e) {
        if (!box || !box.hasAttribute('data-open')) return;
        if (e.key === 'Escape') { closeBox(); return; }
        if (e.key === 'ArrowRight') { point(index + 1); return; }
        if (e.key === 'ArrowLeft') { point(index - 1); return; }
        if (e.key !== 'Tab') return;
        var items = panel.querySelectorAll('button');
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      });

      /* ---------- expandables: content eases in and out, the box itself never animates ---------- */
      pdp.querySelectorAll('[data-fold]').forEach(function (fold) {
        var body = fold.querySelector('[data-fold-body]');
        fold.querySelector('summary').addEventListener('click', function (e) {
          if (!animated()) return;
          var M = window.Motion;
          if (fold.open) {
            e.preventDefault();
            window.gsap.to(body, {
              opacity: 0, y: -8, duration: M.dur.fast, ease: M.ease.exit,
              onComplete: function () { fold.open = false; window.gsap.set(body, { clearProps: 'opacity,transform' }); }
            });
          } else {
            requestAnimationFrame(function () {
              window.gsap.fromTo(body, { opacity: 0, y: 12 }, { opacity: 1, y: 0, duration: M.dur.base, ease: M.ease.enter, clearProps: 'opacity,transform' });
            });
          }
        });
      });

      /* ---------- purchase type ---------- */
      pdp.addEventListener('change', function (e) {
        if (!e.target.matches('[data-pdp-plan]')) return;
        pdp.querySelectorAll('[data-pdp-price]').forEach(function (el) { el.textContent = e.target.getAttribute('data-price'); });
      });

      /* ---------- buy bar: away only while the ticket's own button is on screen ---------- */
      var bar = pdp.querySelector('[data-buy-bar]');
      var submit = pdp.querySelector('.pdp__submit');
      if (bar && submit && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var seen = entries[0].isIntersecting;
          bar.toggleAttribute('data-away', seen);
          bar.toggleAttribute('inert', seen);
        }, { threshold: 0.6 }).observe(submit);
      }

      /* ---------- the toggle is a product switch here ---------- */
      var mine = pdp.getAttribute('data-cast');
      var siblingUrl = pdp.getAttribute('data-sibling-url');
      document.addEventListener('strippers:cast', function (e) {
        if (!siblingUrl || e.detail.cast === mine) return;
        setTimeout(function () { window.location.href = siblingUrl; }, mq.matches ? 0 : 360);
      });

      /* ---------- motion: entrance, lean, reveals ---------- */
      window.onMotion(function () {
        if (!animated()) return;
        var M = window.Motion;
        var gsap = window.gsap;
        var poster = pdp.querySelector('.pdp__poster');
        var entering = false;
        var stage = M.poses.stage(pdp.querySelector('[data-pdp-mascot] [data-mascot]'), { busy: function () { return entering; }, active: function () { return true; }, toggle: false });
        stage.idle(true);
        (window.requestIdleCallback || setTimeout)(function () { stage.warmAll(); });
        if (performance.now() < 2000 && window.scrollY < 40) {
          entering = true;
          // The mascot and the first gallery image are LCP candidates: they move, never fade.
          gsap.timeline({ defaults: { ease: M.ease.enter }, onComplete: function () { entering = false; } })
            .from(pdp.querySelector('[data-pdp-word]'), { x: -32, duration: M.dur.slow }, 0)
            .from(pdp.querySelector('.pdp__mascot'), { y: 40, duration: M.dur.slow }, 0)
            .from(pdp.querySelector('.pdp__frame'), { y: 24, duration: M.dur.slow }, 0.06)
            .from(pdp.querySelectorAll('.pdp__thumb'), { y: 12, opacity: 0, duration: M.dur.base, stagger: M.stagger, clearProps: 'opacity,transform' }, 0.2);
        }
        M.reveal(pdp.querySelectorAll('[data-pdp-reveal]'), { trigger: pdp.querySelector('.pdp__story'), stagger: M.stagger * 2 });
        M.reveal(pdp.querySelectorAll('[data-fold]'), { trigger: pdp.querySelector('[data-folds]') });

        var lean = { x: 0, y: 0, tx: 0, ty: 0, on: false };
        function tick() {
          lean.x += (lean.tx - lean.x) * 0.08;
          lean.y += (lean.ty - lean.y) * 0.08;
          poster.style.setProperty('--lean-x', lean.x.toFixed(3));
          poster.style.setProperty('--lean-y', lean.y.toFixed(3));
          if (Math.abs(lean.tx - lean.x) < 0.002 && Math.abs(lean.ty - lean.y) < 0.002) { gsap.ticker.remove(tick); lean.on = false; }
        }
        function leanTo(x, y) {
          lean.tx = Math.max(-1, Math.min(1, x));
          lean.ty = Math.max(-1, Math.min(1, y));
          if (!lean.on) { lean.on = true; gsap.ticker.add(tick); }
        }
        poster.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse') return;
          var r = poster.getBoundingClientRect();
          leanTo(((e.clientX - r.left) / r.width) * 2 - 1, ((e.clientY - r.top) / r.height) * 2 - 1);
        });
        poster.addEventListener('mouseleave', function () { leanTo(0, 0); });
      });
    }

    function init(scope) { scope.querySelectorAll('[data-pdp]').forEach(setup); }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-rail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(wrap) {
      var M = window.Motion;
      var track = wrap.querySelector('[data-rail-track]');
      if (!M || !track || wrap.hasAttribute('data-ready')) return;
      wrap.setAttribute('data-ready', '');
      var gsap = window.gsap;

      // Stars fill in one by one the first time a card is seen.
      wrap.querySelectorAll('[data-review]').forEach(function (card) {
        var stars = card.querySelectorAll('.review__star');
        M.onEnter(card, function (instant) {
          if (!instant) gsap.from(stars, { opacity: 0.2, scale: 0.6, duration: M.dur.fast, stagger: 0.04, ease: M.ease.enter, clearProps: 'opacity,transform' });
        });
      });

      if (M.reduced) return;
      // Slow auto-drift (~20px/s), there and back. Any interaction parks it; 2s of quiet resumes.
      var dir = 1;
      var pos = 0;
      var running = false;
      var inView = false;
      var idle = null;
      function tick(time, delta) {
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 0) return;
        pos += dir * 20 * (delta / 1000);
        if (pos >= max) { pos = max; dir = -1; }
        if (pos <= 0) { pos = 0; dir = 1; }
        track.scrollLeft = pos;
      }
      function start() {
        if (running || !inView) return;
        running = true;
        pos = track.scrollLeft;
        track.setAttribute('data-gliding', '');
        gsap.ticker.add(tick);
      }
      function stop() {
        clearTimeout(idle);
        if (!running) return;
        running = false;
        gsap.ticker.remove(tick);
        if (!track.hasAttribute('data-dragging')) track.removeAttribute('data-gliding');
      }
      function rest() { stop(); idle = setTimeout(start, 2000); }
      ['mouseenter', 'pointerdown', 'touchstart', 'focusin', 'wheel', 'keydown'].forEach(function (type) {
        wrap.addEventListener(type, stop, { passive: true });
      });
      ['mouseleave', 'touchend', 'touchcancel', 'focusout'].forEach(function (type) {
        wrap.addEventListener(type, rest, { passive: true });
      });
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        inView ? rest() : stop();
      }, { threshold: 0.2 }).observe(wrap);
    }
    function init(scope) { window.onMotion(function () { scope.querySelectorAll('[data-reviews]').forEach(setup); }); }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
